/**
 * WebSmStamp — every step of the chain done: the completion card and the
 * seal press, then on to the debrief by the same branches the live mission
 * reports in with (VOICE, else CANTTALK, else CLICK1).
 */
import { useEffect } from "react";
import { useFunnelStore, useStepperStore } from "@/store";
import {
  useAcceptedMission,
  useMissionFile,
} from "@/features/funnel/api/use-mission-file";
import { useMissionProgress } from "@/store/mission-progress";
import { tierOfLevel } from "./open-case";
import { chainFor, progressKey, stepsFor } from "./mission-steps";
import { MissionSteps } from "./steps-file";
import type { StepTypeProps } from "./types";

export default function WebSmStampType({ dispatch }: StepTypeProps) {
  const missionId = useFunnelStore((s) => s.missionId);
  const graph = useStepperStore((s) => s.graph);
  const goTo = useStepperStore((s) => s.goTo);
  const branches = useStepperStore(
    (s) => s.graph?.steps[s.currentStepName]?.branches,
  );
  const { data: mission } = useAcceptedMission();
  const { data: filed = [] } = useMissionFile();
  const storedTier = useFunnelStore((s) => s.tier);
  const handler = useFunnelStore((s) => s.handler);
  const tier = storedTier ?? tierOfLevel(mission?.level) ?? "beginner";
  const chain = missionId == null ? [] : chainFor(graph, missionId);
  const steps = chain.length
    ? chain.map((s) => s.text)
    : mission
      ? stepsFor(mission)
      : [];
  const done = steps.map((_, i) => i);
  const setDone = useMissionProgress((s) => s.setDone);
  useEffect(() => {
    if (missionId != null) setDone(progressKey(missionId), done);
    // once, on arrival
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [missionId]);
  const reportIn = () => {
    const has = (e: string) => branches?.some((b) => b.eventV === e);
    if (has("VOICE")) dispatch("VOICE");
    else if (has("CANTTALK")) dispatch("CANTTALK");
    else if (has("CLICK1")) dispatch("CLICK1");
    else goTo("Delivered");
  };

  if (!mission || !steps.length) return null;
  return (
    <MissionSteps
      tier={tier}
      mission={mission}
      handler={handler}
      missionNo={filed.length + 1}
      steps={steps}
      done={done}
      settled
      onTick={() => {}}
      onUntick={(i) => (chain[i] ? goTo(chain[i].stepName) : undefined)}
      onStamp={reportIn}
      onClose={() => goTo("Delivered")}
    />
  );
}
